(function () {
  var CITY_KEY = 'bh_selected_city';
  var TIME_KEY = 'bh_city_selected_at';
  var EXPIRY = 60 * 60 * 1000; // 1 hour
  var ERROR_TEXT = 'This product is only for Karachi customers.';

  var validateTimer = null;
  var observer = null;

  function getCity() {
    var city = localStorage.getItem(CITY_KEY);
    var time = parseInt(localStorage.getItem(TIME_KEY), 10);

    if (!city || !time) return null;

    if (Date.now() - time > EXPIRY) {
      localStorage.removeItem(CITY_KEY);
      localStorage.removeItem(TIME_KEY);
      return null;
    }

    return city;
  }

  function setCity(city) {
    localStorage.setItem(CITY_KEY, city);
    localStorage.setItem(TIME_KEY, String(Date.now()));
    closePopup();
    updateFloating();

    setTimeout(function () {
      validateCart();
    }, 300);
  }

  function isOtherCities() {
    return getCity() === 'other_cities';
  }

  function cityLabel() {
    var city = getCity();
    if (city === 'karachi') return 'Karachi';
    if (city === 'other_cities') return 'Other Cities';
    return '';
  }

  function isCartDrawerOpen() {
    return !!(
      document.querySelector('cart-drawer.active') ||
      document.querySelector('#CartDrawer.active') ||
      document.querySelector('.drawer.active') ||
      document.body.classList.contains('overflow-hidden')
    );
  }

  function buildUI() {
    if (document.querySelector('#bh-city-overlay')) return;

    var overlay = document.createElement('div');
    overlay.id = 'bh-city-overlay';
    overlay.className = 'bh-city-overlay';
    overlay.innerHTML =
      '<div class="bh-city-modal">' +
        '<h2>Select Your City</h2>' +
        '<p>Please select your delivery city to continue shopping.</p>' +
        '<div class="bh-city-buttons">' +
          '<button type="button" class="bh-city-btn" data-bh-city="karachi">Karachi</button>' +
          '<button type="button" class="bh-city-btn bh-light" data-bh-city="other_cities">Other Cities</button>' +
        '</div>' +
      '</div>';

    document.body.appendChild(overlay);

    var floating = document.createElement('button');
    floating.type = 'button';
    floating.id = 'bh-city-floating';
    floating.className = 'bh-city-floating';
    document.body.appendChild(floating);

    document.addEventListener('click', function (event) {
      var cityBtn = event.target.closest('[data-bh-city]');
      if (cityBtn) {
        setCity(cityBtn.getAttribute('data-bh-city'));
      }

      if (event.target.closest('#bh-city-floating')) {
        openPopup();
      }
    });

    updateFloating();

    if (!getCity()) {
      openPopup();
    }
  }

  function openPopup() {
    var overlay = document.querySelector('#bh-city-overlay');
    if (!overlay) return;
    overlay.classList.add('bh-show');
    document.body.classList.add('bh-city-modal-open');
  }

  function closePopup() {
    var overlay = document.querySelector('#bh-city-overlay');
    if (!overlay) return;
    overlay.classList.remove('bh-show');
    document.body.classList.remove('bh-city-modal-open');
  }

  function updateFloating() {
    var floating = document.querySelector('#bh-city-floating');
    if (!floating) return;

    var label = cityLabel();

    if (!label || isCartDrawerOpen()) {
      floating.classList.remove('bh-show');
      return;
    }

    floating.innerHTML = 'Delivering to: ' + label + ' | Change';
    floating.classList.add('bh-show');
  }

  function showToast(message) {
    var oldToast = document.querySelector('.bh-city-toast');
    if (oldToast) oldToast.remove();

    var toast = document.createElement('div');
    toast.className = 'bh-city-toast';
    toast.textContent = message;
    document.body.appendChild(toast);

    setTimeout(function () {
      toast.remove();
    }, 3500);
  }

  function isKarachiOnlyElement(element) {
    if (!element) return false;

    if (element.closest('[data-bh-karachi-only="true"]')) return true;
    if (element.closest('[data-bh-karachi-card="true"]')) return true;

    if (window.BH_PRODUCT_KARACHI_ONLY === true) {
      if (
        element.closest('product-form') ||
        element.closest('form[action*="/cart/add"]') ||
        element.closest('form[data-type="add-to-cart-form"]')
      ) {
        return true;
      }
    }

    return false;
  }

  function cartHasKarachiOnly() {
    if (window.BH_CART_HAS_KARACHI_ONLY === true) return true;
    if (document.querySelector('[data-bh-cart-karachi-only="true"]')) return true;
    return false;
  }

  function blockAction(event) {
    event.preventDefault();
    event.stopPropagation();

    if (typeof event.stopImmediatePropagation === 'function') {
      event.stopImmediatePropagation();
    }

    showToast(ERROR_TEXT);

    setTimeout(function () {
      validateCart();
    }, 300);

    return false;
  }

  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form) return;

    var isAddToCartForm =
      form.matches('form[action*="/cart/add"]') ||
      form.matches('form[data-type="add-to-cart-form"]');

    if (!isAddToCartForm) return;

    if (!getCity()) {
      blockAction(event);
      openPopup();
      return;
    }

    if (isOtherCities() && isKarachiOnlyElement(form)) {
      blockAction(event);
    }
  }, true);

  document.addEventListener('click', function (event) {
    var addButton = event.target.closest(
      'button[name="add"], .quick-add__submit, product-form button[type="submit"], form[action*="/cart/add"] button[type="submit"]'
    );

    if (addButton) {
      if (!getCity()) {
        blockAction(event);
        openPopup();
        return;
      }

      if (isOtherCities() && isKarachiOnlyElement(addButton)) {
        blockAction(event);
        return;
      }
    }

    var checkoutButton = event.target.closest(
      'button[name="checkout"], #checkout, .cart__checkout-button, a[href="/checkout"], [href="/checkout"]'
    );

    if (checkoutButton && isOtherCities() && cartHasKarachiOnly()) {
      blockAction(event);
    }
  }, true);

  function validateCart() {
    updateFloating();

    var shouldBlock = isOtherCities() && cartHasKarachiOnly();

    document.querySelectorAll('.bh-cart-city-error').forEach(function (el) {
      el.remove();
    });

    var checkoutButtons = document.querySelectorAll(
      'button[name="checkout"], #checkout, .cart__checkout-button, a[href="/checkout"], [href="/checkout"]'
    );

    checkoutButtons.forEach(function (btn) {
      if (shouldBlock) {
        btn.setAttribute('aria-disabled', 'true');

        if (btn.tagName === 'BUTTON') {
          if (!btn.hasAttribute('data-bh-disabled-by-city')) {
            if (btn.hasAttribute('disabled')) {
              btn.setAttribute('data-bh-was-disabled', 'true');
            }
            btn.setAttribute('data-bh-disabled-by-city', 'true');
          }

          btn.setAttribute('disabled', 'disabled');
        }

        btn.classList.add('bh-city-checkout-blocked');
      } else {
        btn.removeAttribute('aria-disabled');
        btn.classList.remove('bh-city-checkout-blocked');

        if (btn.hasAttribute('data-bh-disabled-by-city')) {
          if (!btn.hasAttribute('data-bh-was-disabled')) {
            btn.removeAttribute('disabled');
          }

          btn.removeAttribute('data-bh-disabled-by-city');
          btn.removeAttribute('data-bh-was-disabled');
        }
      }
    });

    if (shouldBlock) {
      var target =
        document.querySelector('.drawer__footer') ||
        document.querySelector('.cart__footer') ||
        document.querySelector('#main-cart-footer');

      if (target && !target.querySelector('.bh-cart-city-error')) {
        var error = document.createElement('div');
        error.className = 'bh-cart-city-error';
        error.textContent = ERROR_TEXT;
        target.prepend(error);
      }
    }
  }

  function safeValidateCart() {
    clearTimeout(validateTimer);

    validateTimer = setTimeout(function () {
      if (observer) observer.disconnect();

      validateCart();

      setTimeout(function () {
        startObserver();
      }, 600);
    }, 350);
  }

  function startObserver() {
    if (observer) observer.disconnect();

    var target =
      document.querySelector('cart-drawer') ||
      document.querySelector('#CartDrawer') ||
      document.querySelector('#main-cart-items') ||
      document.querySelector('#main-cart-footer');

    if (!target) return;

    observer = new MutationObserver(function () {
      safeValidateCart();
    });

    observer.observe(target, {
      childList: true,
      subtree: true
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    buildUI();

    setTimeout(function () {
      validateCart();
      startObserver();
    }, 500);
  });
})();